export const OTP_METHODS = {
    SMS: "SMS",
    EMAIL: "EMAIL"
} as const;

export type OtpMethod =
    (typeof OTP_METHODS)[keyof typeof OTP_METHODS];